import { ReactNode } from 'react';
import clsx from 'clsx/lite';
import styles from './FieldWrapper.module.css';

interface FieldWrapperProps {
  label: string | ReactNode;
  value: ReactNode;
  indented?: boolean;
  labelClassname?: string;
}
const FieldWrapper = (props: FieldWrapperProps) => {
  const { label, value, indented, labelClassname } = props;

  return (
    <div className={clsx(styles.wrapper, indented && styles.indented)}>
      <div className={clsx(styles.label, labelClassname)}>{label}</div>
      <div className={styles.value}>{value}</div>
    </div>
  );
};

export default FieldWrapper;
